/* ==========================================================================
   BLAST RADIO — THEME JS
   --------------------------------------------------------------------------
   Vanilla JS, no dependencies. Each module runs only if its DOM hook exists,
   so this file can be loaded on every page without errors.
   ========================================================================== */

(function () {
  'use strict';

  /* ========================================================================
     Lock-in scrollytelling driver
     ------------------------------------------------------------------------
     The pin spacer is N × 100vh tall, with a sticky pin inside that holds
     the layout in place for the whole duration. Scroll progress (0 → 1)
     determines which step is active.
     ======================================================================== */
  function initScrolly(root) {
    var spacer  = root.querySelector('.scrolly-pin-spacer');
    var steps   = [].slice.call(root.querySelectorAll('.scrolly-step'));
    var imgs    = [].slice.call(root.querySelectorAll('.sf-img'));
    var ticks   = [].slice.call(root.querySelectorAll('.scrolly-progress span'));
    var capNum  = root.querySelector('.scrolly-caption .caption-num');
    var capText = root.querySelector('.scrolly-caption .caption-text');
    var mobileFill = root.querySelector('.scrolly-mobile-progress-fill');
    if (!spacer || !steps.length || !imgs.length) return;

    var stepCount = steps.length;
    var current = 0;

    function activate(idx) {
      if (idx === current) return;
      steps[current].classList.remove('is-active');
      imgs[current].classList.remove('is-active');
      if (ticks[current]) ticks[current].classList.remove('is-active');
      steps[idx].classList.add('is-active');
      imgs[idx].classList.add('is-active');
      if (ticks[idx]) ticks[idx].classList.add('is-active');
      current = idx;

      var n = (idx + 1).toString();
      if (n.length < 2) n = '0' + n;
      if (capNum)  capNum.textContent = n;
      if (capText) capText.textContent = steps[idx].getAttribute('data-caption') || '';
    }

    var ticking = false;
    function update() {
      var rect = spacer.getBoundingClientRect();
      var totalScrollable = spacer.offsetHeight - window.innerHeight;
      if (totalScrollable <= 0) { ticking = false; return; }
      var scrolled = -rect.top;
      var progress = Math.max(0, Math.min(1, scrolled / totalScrollable));
      var idx = Math.floor(Math.min(0.9999, progress) * stepCount);
      idx = Math.max(0, Math.min(stepCount - 1, idx));
      activate(idx);
      if (mobileFill) {
        mobileFill.style.width = (progress * 100) + '%';
      }
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ========================================================================
     Image rotator (used in product hero)
     ======================================================================== */
  function initRotator(root) {
    var frames = root.querySelectorAll('.rotator-frame');
    var label  = root.querySelector('[data-rotator-label]');
    var phrasesAttr = root.getAttribute('data-rotator-phrases');
    var phrases = phrasesAttr ? phrasesAttr.split('|') : ['Press the red button', 'On Air'];
    if (!frames.length) return;

    var i = 0;
    var p = 0;
    setInterval(function () {
      frames[i].classList.remove('is-active');
      i = (i + 1) % frames.length;
      frames[i].classList.add('is-active');
      if (label) {
        p = (p + 1) % phrases.length;
        label.style.opacity = '0';
        setTimeout(function () {
          label.textContent = phrases[p];
          label.style.transition = 'opacity 0.35s ease';
          label.style.opacity = '1';
        }, 250);
      }
    }, 3800);
  }

  /* ========================================================================
     Mobile nav toggle
     ======================================================================== */
  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-toggle]');
    var panel  = document.querySelector('[data-mobile-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var isOpen = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Close panel when a link inside it is clicked
    panel.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  }

  /* ========================================================================
     PDP variant picker + add-to-cart
     ------------------------------------------------------------------------
     Reads variant data from a JSON script tag, swaps the selected variant
     based on option clicks, updates price + image + add-to-cart state.
     ======================================================================== */
  function initPDP() {
    var pdp = document.querySelector('[data-pdp]');
    if (!pdp) return;

    var dataNode = pdp.querySelector('[data-pdp-variants]');
    if (!dataNode) return;
    var variants;
    try { variants = JSON.parse(dataNode.textContent); }
    catch (e) { console.error('Invalid variant JSON', e); return; }

    var optionEls = pdp.querySelectorAll('[data-pdp-option]');
    var priceEl   = pdp.querySelector('[data-pdp-price]');
    var compareEl = pdp.querySelector('[data-pdp-compare]');
    var addBtn    = pdp.querySelector('[data-pdp-add]');
    var variantIdInput = pdp.querySelector('[data-pdp-variant-id]');
    var availabilityEl = pdp.querySelector('[data-pdp-availability]');

    var selectedOptions = {};

    // Initialize selectedOptions with first available option of each kind
    optionEls.forEach(function (el) {
      var name = el.getAttribute('data-option-name');
      if (!(name in selectedOptions)) {
        selectedOptions[name] = el.getAttribute('data-option-value');
        el.classList.add('is-active');
      }
    });

    function findVariant() {
      return variants.find(function (v) {
        return Object.keys(selectedOptions).every(function (name) {
          return v.options[name] === selectedOptions[name];
        });
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function update() {
      var v = findVariant();
      if (!v) return;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (variantIdInput) variantIdInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (addBtn.getAttribute('data-label-add') || 'Add to cart') : (addBtn.getAttribute('data-label-soldout') || 'Sold out');
      }
      if (availabilityEl) {
        availabilityEl.textContent = v.available ? 'In stock' : 'Sold out';
      }
    }

    optionEls.forEach(function (el) {
      el.addEventListener('click', function () {
        var name = el.getAttribute('data-option-name');
        var value = el.getAttribute('data-option-value');
        selectedOptions[name] = value;
        // Toggle active state within the same option group
        pdp.querySelectorAll('[data-option-name="' + name + '"]').forEach(function (sib) {
          sib.classList.remove('is-active');
        });
        el.classList.add('is-active');
        update();
      });
    });

    update();
  }

  /* ========================================================================
     Cart quantity controls (cart page)
     ======================================================================== */
  function initCartControls() {
    var cart = document.querySelector('[data-cart]');
    if (!cart) return;

    cart.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-qty]');
      if (!btn) return;
      var dir = btn.getAttribute('data-cart-qty');
      var input = btn.parentElement.querySelector('input[type="number"]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v = dir === 'inc' ? v + 1 : Math.max(0, v - 1);
      input.value = v;
      // Submit the parent form (which posts to /cart/change.js or similar)
      var form = input.closest('form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  /* ========================================================================
     Init everything when DOM is ready
     ======================================================================== */
  function init() {
    document.querySelectorAll('[data-scrolly]').forEach(initScrolly);
    document.querySelectorAll('[data-rotator]').forEach(initRotator);
    initMobileNav();
    initPDP();
    initCartControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
